export async function reqAPI(
  route,
  params = {},
  method = "GET",
  isFormData = false,
  responseType = "json"
) {
  const backendApi = process.env.BACKEND_API || "https://api.swiftrans.id";
  // if (!process.env.BACKEND_API) {
  //   console.warn(
  //     "Warning: BACKEND_API is not defined. Using fallback value:",
  //     backendApi
  //   );
  // }

  let url = `${backendApi}/${route}`;
  try {
    const options = {
      method,
      headers: {},
      // credentials: 'include',
    };

    const token = localStorage.getItem("auth_token");
    if (token) {
      options.headers["Authorization"] = `Bearer ${token}`;
      options.headers["Cookie"] = `XSRF-TOKEN=${token}`;
    }

    if (isFormData) {
      options.body = params;
    } else if (method !== "GET" && method !== "HEAD") {
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(params);
    }

    if (method === "GET" && params && Object.keys(params).length > 0) {
      const queryString = new URLSearchParams(params).toString();
      url += `?${queryString}`;
    }

    const response = await fetch(url, options);

    // Parse the response data first
    // const data = await response.json(); // Old way

    // Handle different response types
    let data;
    if (responseType === "blob") {
      if (response.ok) {
        data = await response.blob();
      } else {
        // For non-ok responses that were expected as blob, try to parse error as JSON
        try {
          data = await response.json();
        } catch (e) {
          // If JSON parsing fails, use text as a fallback for the error message
          data = {
            message:
              (await response.text()) ||
              `Request failed with status ${response.status}`,
          };
        }
      }
    } else {
      // Default to json
      data = await response.json();
    }

    // if(response.status === 500){
    //   window.location.href = '/signin';
    //   return;
    // }

    if (!response.ok) {
      // For validation errors (422) and other error responses,
      // throw an error with the response data
      const error = new Error(data.message || "API request failed"); // Use message from parsed data if available
      error.response = {
        status: response.status,
        data: data, // data here could be JSON error or Blob (if !response.ok and responseType was blob)
      };
      throw error;
    }

    return data;
  } catch (error) {
    console.error(`Failed to fetch data from ${route}:`, error);
    // If the error already has a response object, throw it as is
    if (error.response) {
      throw error;
    }
    // Otherwise wrap it in a response-like object
    const wrappedError = new Error();
    wrappedError.response = {
      status: 500,
      data: {
        message: error.message || "An unexpected error occurred",
      },
    };
    throw wrappedError;
  }
}
